
import { z } from "zod";


export const FormSchema = z.object({
  name: z.string().min(1, { message: "This field has to be filled !" }),
  phone: z.string().min(10, { message: "Must be a valid mobile number" }),
  message: z
    .string()
    .min(15, { message: "Message must contain more the 15 character !" }),
  email: z
    .string()
    .min(1, { message: "This field has to be filled !" })
    .email("This is not a valid email !"),
});
